/*
 * @Description:
 * @Date: 2020-07-27 11:25:02
 */

import { mapState } from 'vuex';
import { debounce } from 'lodash';

export const loadMore = {
  data() {
    return {
      loading: true,
      hasMore: true,
      listData: [],
      pageObj: {
        pageNo: 1,
        pageSize: 20
      },
      listAjax: null,
      listTotal: 0,
      listResultOtions: {}
    };
  },
  computed: {
    ...mapState({
      isDesktop: state => state.living.isDesktop
    })
  },
  methods: {
    /**
     * @description: 接口调用，可外部覆盖
     * @return: 必须返回Promise并含有三个必有参数{list, hasMore, total, ...options}
     */
    async listFunc(query = {}) {
      try {
        let {
          data: { data }
        } = await this.listAjax({ ...this.pageObj, ...query });
        return Promise.resolve(data);
      } catch (e) {
        console.error(e);
        return Promise.reject();
      }
    },
    /**
     * @description: 修改列表对应状态与调用列表方法
     * @param {type}
     * @return {type}
     */
    async getList(args) {
      let formatArgs = {
        init: false,
        staticRefresh: false
      };
      Object.assign(formatArgs, args);
      let { init, staticRefresh } = formatArgs;
      this.loading = true;
      if (init) {
        !staticRefresh && (this.listData = []);
        this.hasMore = true;
        this.pageObj.pageNo = 1;
      }
      try {
        let { list, hasMore, total, ...options } = await this.listFunc(
          formatArgs
        );
        this.listData =
          staticRefresh && init ? list : this.listData.concat(list);
        this.pageObj.pageNo += 1;
        // 如果传入notUseHasMore字段，则不使用后端返回的hasMore字段
        this.hasMore = this.notUseHasMore
          ? Array.isArray(list)
            ? list.length > 0
            : hasMore
          : hasMore;
        this.listTotal = total || 0;
        this.listResultOtions = options;
      } catch (e) {}
      this.loading = false;
    },
    // 滑动
    async preLoad(args) {
      const el =
        document.querySelector('#listScroll') ||
        this.$refs.listScroll ||
        document.querySelector('body');
      const innerHeight = el.clientHeight;
      const scrollTop = Math.max(
        el.scrollTop,
        document.documentElement.scrollTop,
        window.pageYOffset,
        document.body.scrollTop
      );
      const scrollHeight = Math.max(el.clientHeight || 0, el.scrollHeight || 0);
      // 布局导致scrollHeight不适用;
      // if (
      //   scrollTop / scrollHeight >= 0.5 &&
      //   !this.loading &&
      //   this.hasMore &&
      //   !this.isDesktop
      // ) {
      //   await this.getList(args);
      // }
      if (
        scrollHeight - scrollTop <= 1000 &&
        !this.loading &&
        this.hasMore
        // this.isDesktop
      ) {
        await this.getList(args);
      }
    }
  },
  watch: {},
  created() {}
};
